import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Offer details',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Set the qualifying spend and % discount',
      qualifying_criteria: {
        title: 'Minimum spend amount',
        description: 'Set the qualifying spend amount',
      },
      details: {
        title: '% discount',
        description: 'Set the discount amount that customers will get off their order',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Set the qualifying items spend and % discount',
      qualifying_criteria: {
        title: 'Discounted items',
        description: "Select the items that you're offering a discount on.",
      },
      details: {
        title: '% discount',
        description: 'Set the discount amount that customers will get off their order',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Set the qualifying items and {{currency}} discount',
      qualifying_criteria: {
        title: 'Discounted items',
        description: "Select the items that you're offering a discount on.",
      },
      details: {
        title: '{{currency}} discount',
        description: 'Set the discount amount that customers will get off their order',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Set the qualifying spend and {{currency}} discount',
      qualifying_criteria: {
        title: 'Minimum spend amount',
        description: 'Set the qualifying spend amount',
      },
      details: {
        title: '{{currency}} discount',
        description: 'Set the discount amount that customers will get off their order',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Set the qualifying spend and free items',
      qualifying_criteria: {
        title: 'Minimum spend amount',
        description: 'Set the amount the customer must spend to get the free item.',
      },
      details: {
        title: 'Free items:',
        description: 'Select the free item (or items) that the customer can choose one from.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Pick the requirements in the offer',
      qualifying_criteria: {
        title: 'Qualifying items',
        description: 'Select the items the customer must order to get the free item.',
      },
      details: {
        title: 'Free items:',
        description: 'Select the free item (or items) that the customer can choose one from.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Pick the requirements in the offer',
      qualifying_criteria: {
        title: 'Qualifying items',
        description: 'Select the category that the customer must choose from to get a free item.',
      },
      details: {
        title: 'Free item',
        description:
          "Customers can select their second item from the qualifying items you've selected. The customer will get the cheapest of the two items free.",
      },
    },
  },
};
